// extracted by mini-css-extract-plugin
export default {"checkout_summary":"SG","checkout_summary_wrapper":"TG","summary_items":"UG","line_items_wrapper":"VG","separator":"WG","order_summary":"XG","line_item":"YG","order__summary_item_title":"ZG","recurringdis":"aH","note":"bH","carbon_emission":"cH","unlock_savings":"eH","member_perk":"fH","info":"gH","no_items":"hH","promo":"iH","order_summary_mobile":"jH","open_summary_mobile":"kH","fixed_bottom_info":"lH","open_info":"mH","text":"nH","open_summary":"oH"};
    if(module.hot) {
      // 1743628927220
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  